<div class="container-fluid" style="max-width: 80rem; margin-top: 60px">
  <div class="row">
    <div class="col-12">
      <div
        class="card card-solid card-bg-transparent mt-4 overflow-hidden rounded-tix"
      >
        <div class="row g-0">
          <!-- Event Cover Image -->
          <div class="col-12 col-md-auto">
            <div
              class="position-relative"
              style="height: 264px; overflow: hidden"
            >
              <img
                *ngIf="!isLoading && order?.event?.cover?.[0]?.url"
                [src]="
                  order?.event?.cover[0]?.formats?.url ||
                  order?.event?.cover[0].url
                "
                class="w-100 h-100"
                style="object-fit: cover; min-width: 264px"
                [alt]="order?.event?.name"
              />
              <div
                *ngIf="isLoading"
                class="w-100 h-100 bg-secondary placeholder-glow"
              >
                <div class="placeholder w-100 h-100"></div>
              </div>
            </div>
          </div>

          <!-- Event Details -->
          <div class="col-12 col-md">
            <div class="d-flex flex-column gap-3 p-4">
              <div class="placeholder-glow">
                <h4 *ngIf="isLoading" class="placeholder col-8 mb-0"></h4>
                <h4 *ngIf="!isLoading" class="fw-bold mb-0">
                  {{ order?.event?.name }}
                </h4>
              </div>

              <!-- Date Info -->
              <div class="d-flex align-items-start gap-2">
                <span class="fs-5" *ngIf="!isLoading">
                  <img
                    src="assets/img/emojis/calendar.svg"
                    alt="calendar"
                    loading="lazy"
                    width="20"
                  />
                </span>
                <span class="fs-5 placeholder-glow" *ngIf="isLoading">
                  <div class="placeholder rounded-circle" style="width: 20px; height: 20px;"></div>
                </span>
                <div class="flex-grow-1 placeholder-glow">
                  <p *ngIf="isLoading" class="placeholder col-6 mb-0"></p>
                  <p
                    [hidden]="isLoading"
                    class="mb-0 text-dark mt-1"
                    style="text-transform: capitalize"
                    *ngFor="let date of dates"
                  >
                    {{ date | customDate : 'date' }}
                  </p>
                </div>
              </div>

              <!-- Time Info -->
              <div class="d-flex align-items-start gap-2">
                <span class="fs-5" *ngIf="!isLoading">
                  <img
                    src="assets/img/emojis/clock.svg"
                    alt="clock"
                    loading="lazy"
                    width="20"
                  />
                </span>
                <span class="fs-5 placeholder-glow" *ngIf="isLoading">
                  <div class="placeholder rounded-circle" style="width: 20px; height: 20px;"></div>
                </span>
                <div class="flex-grow-1 placeholder-glow">
                  <p *ngIf="isLoading" class="placeholder col-4 mb-0"></p>
                  <ng-container *ngIf="!isLoading">
                    <p class="mb-0 text-dark mt-1" *ngFor="let date of dates">
                      {{ date | customDate : 'time' }}
                    </p>
                  </ng-container>
                </div>
              </div>

              <!-- Location Info -->
              <div class="d-flex align-items-start gap-2">
                <span class="fs-5" *ngIf="!isLoading">
                  <img
                    src="assets/img/emojis/location.svg"
                    alt="map emoji"
                    loading="lazy"
                    width="20"
                  />
                </span>
                <span class="fs-5 placeholder-glow" *ngIf="isLoading">
                  <div class="placeholder rounded-circle" style="width: 20px; height: 20px;"></div>
                </span>
                <div class="flex-grow-1 placeholder-glow">
                  <p *ngIf="isLoading" class="placeholder col-7 mb-0"></p>
                  <div
                    [hidden]="isLoading"
                    class="mb-0 mt-1"
                    *ngFor="let place of places"
                  >
                    <p class="mb-0">
                      {{ place.place }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="row gap-2 gap-md-3">
                <button
                  *ngIf="isGoogleMapsLink(order?.event?.link)"
                  class="btn-custom-light w-fit"
                  (click)="openAllLocations()"
                >
                  <span class="fs-6">
                    <img
                      src="assets/img/emojis/compass.svg"
                      alt="compass emoji"
                      loading="lazy"
                      width="16"
                      style="margin-bottom: 2px"
                    />
                  </span>
                  <p class="mb-0">Obtener Direcciones</p>
                </button>

                <div class="placeholder-glow w-fit" *ngIf="isLoading">
                  <div class="placeholder rounded-pill" style="width: 100%; height: 32px;"></div>
                </div>

                <button
                  *ngIf="!isLoading"
                  class="btn-custom-light w-fit"
                  (click)="addToCalendar()"
                >
                  <span class="fs-6">
                    <img
                      src="assets/img/emojis/calendar.svg"
                      alt="calendar"
                      loading="lazy"
                      width="16"
                      style="margin-bottom: 2px"
                    />
                  </span>
                  <p class="mb-0">Añadir al Calendario</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
